/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DeleteRoleRequest} from '../models/DeleteRoleRequest';
import type {EntitlementId} from '../models/EntitlementId';
import type {Error} from '../models/Error';
import type {Role} from '../models/Role';
import type {RoleList} from '../models/RoleList';
import type {UpdateRoleRequest} from '../models/UpdateRoleRequest';

export interface CreateRole$Request {
    role: Role;
}

export interface CreateRole$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createRoleRequest = createAction<PayloadData<void, CreateRole$Request>>('ENTITLEMENTS_ROLE__CREATE_ROLE__REQUEST');
export const createRoleSuccess = createAction<PayloadData<EntitlementId, CreateRole$Request>>('ENTITLEMENTS_ROLE__CREATE_ROLE__SUCCESS');
export const createRoleFailure = createAction<PayloadData<Error, CreateRole$Request, true>>('ENTITLEMENTS_ROLE__CREATE_ROLE__FAILURE');

export const createRoleActions = [
    createRoleRequest,
    createRoleSuccess,
    createRoleFailure
] as const;

/**
 * @param {Role} meta.role
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createRole = (meta: CreateRole$Request, config?: CreateRole$Config) => {
    return {
        CALL_API: {
            types: createRoleActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/entitlements/roles`,
            TRANSPORT_REQUEST_BODY: meta.role,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeleteRole$Request {
    roleId: string;
    deleteRoleRequest: DeleteRoleRequest;
}

export interface DeleteRole$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteRoleRequest = createAction<PayloadData<void, DeleteRole$Request>>('ENTITLEMENTS_ROLE__DELETE_ROLE__REQUEST');
export const deleteRoleSuccess = createAction<PayloadData<void, DeleteRole$Request>>('ENTITLEMENTS_ROLE__DELETE_ROLE__SUCCESS');
export const deleteRoleFailure = createAction<PayloadData<Error, DeleteRole$Request, true>>('ENTITLEMENTS_ROLE__DELETE_ROLE__FAILURE');

export const deleteRoleActions = [
    deleteRoleRequest,
    deleteRoleSuccess,
    deleteRoleFailure
] as const;

/**
 * @param {string} meta.roleId
 * @param {DeleteRoleRequest} meta.deleteRoleRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteRole = (meta: DeleteRole$Request, config?: DeleteRole$Config) => {
    return {
        CALL_API: {
            types: deleteRoleActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/entitlements/roles/${meta.roleId}`,
            TRANSPORT_REQUEST_BODY: meta.deleteRoleRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetRoleNamesByIds$Request {
    requestBody: Array<string>;
}

export interface GetRoleNamesByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getRoleNamesByIdsRequest = createAction<PayloadData<void, GetRoleNamesByIds$Request>>('ENTITLEMENTS_ROLE__GET_ROLE_NAMES_BY_IDS__REQUEST');
export const getRoleNamesByIdsSuccess = createAction<PayloadData<{ [key: string]: Role; }, GetRoleNamesByIds$Request>>('ENTITLEMENTS_ROLE__GET_ROLE_NAMES_BY_IDS__SUCCESS');
export const getRoleNamesByIdsFailure = createAction<PayloadData<Error, GetRoleNamesByIds$Request, true>>('ENTITLEMENTS_ROLE__GET_ROLE_NAMES_BY_IDS__FAILURE');

export const getRoleNamesByIdsActions = [
    getRoleNamesByIdsRequest,
    getRoleNamesByIdsSuccess,
    getRoleNamesByIdsFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getRoleNamesByIds = (meta: GetRoleNamesByIds$Request, config?: GetRoleNamesByIds$Config) => {
    return {
        CALL_API: {
            types: getRoleNamesByIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/roles`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetRolesWithoutRelations$Request {
    pageSize: number;
    pageNumber: number;
}

export interface GetRolesWithoutRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getRolesWithoutRelationsRequest = createAction<PayloadData<void, GetRolesWithoutRelations$Request>>('ENTITLEMENTS_ROLE__GET_ROLES_WITHOUT_RELATIONS__REQUEST');
export const getRolesWithoutRelationsSuccess = createAction<PayloadData<RoleList, GetRolesWithoutRelations$Request>>('ENTITLEMENTS_ROLE__GET_ROLES_WITHOUT_RELATIONS__SUCCESS');
export const getRolesWithoutRelationsFailure = createAction<PayloadData<Error, GetRolesWithoutRelations$Request, true>>('ENTITLEMENTS_ROLE__GET_ROLES_WITHOUT_RELATIONS__FAILURE');

export const getRolesWithoutRelationsActions = [
    getRolesWithoutRelationsRequest,
    getRolesWithoutRelationsSuccess,
    getRolesWithoutRelationsFailure
] as const;

/**
 * @param {number} meta.pageSize
 * @param {number} meta.pageNumber
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getRolesWithoutRelations = (meta: GetRolesWithoutRelations$Request, config?: GetRolesWithoutRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageSize: meta.pageSize,
        pageNumber: meta.pageNumber,
    };
    return {
        CALL_API: {
            types: getRolesWithoutRelationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/roles`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateRole$Request {
    roleId: string;
    updateRoleRequest: UpdateRoleRequest;
}

export interface UpdateRole$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateRoleRequest = createAction<PayloadData<void, UpdateRole$Request>>('ENTITLEMENTS_ROLE__UPDATE_ROLE__REQUEST');
export const updateRoleSuccess = createAction<PayloadData<void, UpdateRole$Request>>('ENTITLEMENTS_ROLE__UPDATE_ROLE__SUCCESS');
export const updateRoleFailure = createAction<PayloadData<Error, UpdateRole$Request, true>>('ENTITLEMENTS_ROLE__UPDATE_ROLE__FAILURE');

export const updateRoleActions = [
    updateRoleRequest,
    updateRoleSuccess,
    updateRoleFailure
] as const;

/**
 * @param {string} meta.roleId
 * @param {UpdateRoleRequest} meta.updateRoleRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateRole = (meta: UpdateRole$Request, config?: UpdateRole$Config) => {
    return {
        CALL_API: {
            types: updateRoleActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/roles/${meta.roleId}`,
            TRANSPORT_REQUEST_BODY: meta.updateRoleRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

